import { render, staticRenderFns } from "./ChecklistDictionaryList.vue?vue&type=template&id=6554f42f&"
import script from "./ChecklistDictionaryList.vue?vue&type=script&lang=js&"
export * from "./ChecklistDictionaryList.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistDictionaryList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports